import {
  getCmsProductGroupListRepo,
  postCmsProductGroupRepo,
  getCmsProductGroupFeatureListRepo,
  postCmsProductGroupFeatureRepo,
  getCmsFeatureGroupRepo,
  getCmsFeatureListRepo,
  postCmsFeatureSynonymRepo,
  postCmsFeatureRepo,
  getCmsProductListRepo,
  postCmsProductRepo,
  getCmsProductTypeListRepo,
  postCmsProductTypeRepo,
  postCmsMapProductFeatureRepo,
  getCmsMapProductFeatureListRepo,
  getCmsLandingPageListRepo,
  postCmsLandingPageRepo,
  getCmsLandingPageFaqListRepo,
  postCmsLandingPageFaqRepo,
  getCmsLandingPageSpgListRepo,
  postCmsLandingPageSpgRepo,
  getCmsLandingPageBannerListRepo,
  getCmsLandingPageBannerRepo,
  postCmsLandingPageBannerRepo,
  getCmsUserProductListRepo,
  postCmsUserProductRepo,
  getCmsFeatureSynonymRepo,
  getCmsUserProductDetailListRepo,
  postCmsUserProductDetailRepo,
  getCmsUserProductDetailRepo,
  editCmsUserProductDetailRepo,
  postCmsUserProductSpgRepo,
  putCmsPaymentDetailUpdateRepo,
  getFeatureGroupsListRepo,
  postCmsFeatureGroupsRepo,
  getCmsProuductMappedEntityRepo,
  getCmsProuductSellebleTypeRepo,
  getCmsProuductMappedEntityCheckRepo,
  getCmsProductSpgTypeRepo,
  getCmsMappedEntityTypeRepo,
  getCmsMappedEntityRepo,
  getCmsLearnEntityRepo,
  getCmsAutoAccessRepo,
  getCmsSpgInterestRepo,
  getCmsAdditionalMappingFieldRepo,
  getCmsEntityValidateRepo,
  getCmsSpgLevelsRepo,
  getCmsProductMappedEntityRepo,
  getMapProductsDataRepo,
  putProductSpgMappingRepo,
  // getCmsProductListDialerRepo
} from "../../repositories/premium/products";

import { postClearEntityCache } from "../../actions";
import { deleteCmsWebinarkeywordsRepo } from "../../repositories/premium/webinar";

export const getCmsProductGroupList = (id, data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_PRODUCTS_LIST_REQUEST" });
    getCmsProductGroupListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_PRODUCTS_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCTS_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCTS_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsProductGroup = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_PRODUCT_GROUP_REQUEST" });
    getCmsProductGroupListRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsProductGroup = (data, id) => {
  return (dispatch) => {
    postCmsProductGroupRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_PRODUCT_GROUP_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "POST_CMS_PRODUCT_GROUP_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsProductSpgTypeList = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_PRODUCT_SPG_TYPE_LIST_REQUEST" });
    getCmsProductSpgTypeRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_PRODUCT_SPG_TYPE_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCT_SPG_TYPE_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FEATURE_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsMappedEntityTypeList = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_MAPPED_TYPE_LIST_REQUEST" });
    getCmsMappedEntityTypeRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_MAPPED_TYPE_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_MAPPED_TYPE_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_MAPPED_TYPE_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

// -------- These Both actions are used for the same Dropdown ----------
export const getCmsMappedEntityList = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_MAPPED_LIST_REQUEST" });
    getCmsMappedEntityRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_MAPPED_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_MAPPED_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_MAPPED_TYPE_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsLearnEntityList = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_MAPPED_LIST_REQUEST" });
    getCmsLearnEntityRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_MAPPED_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_MAPPED_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_MAPPED_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

// ----------------------------------------------- //

export const getCmsAutoAccess = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_AUTO_ACCESS_REQUEST" });
    getCmsAutoAccessRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_AUTO_ACCESS_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_AUTO_ACCESS_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_AUTO _ACCESS_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsSpgInterest = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_SPG_INTEREST_REQUEST" });
    getCmsSpgInterestRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_SPG_INTEREST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_SPG_INTEREST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_SPG_INTEREST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};


export const getCmsAdditionalMappingField = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_ADDITIONAL_MAPPING_FIELD_REQUEST" });
    getCmsAdditionalMappingFieldRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_ADDITIONAL_MAPPING_FIELD_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_ADDITIONAL_MAPPING_FIELD_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_ADDITIONAL_MAPPING_FIELD_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsEntityValidate = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_ENTITY_VALIDATE_REQUEST" });
    getCmsEntityValidateRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_ENTITY_VALIDATE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_ENTITY_VALIDATE_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_ENTITY_VALIDATE_FAILURE",
            payload: error?.response?.data?.data,
          });
        }
      });
  };
};

export const getCmsSpgLevels = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_SPG_LEVELS_REQUEST" });
    getCmsSpgLevelsRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_SPG_LEVELS_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_SPG_LEVELS_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FEATURE_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsProductGroupFeatureList = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_PRODUCT_GROUP_FEATURE_LIST_REQUEST" });
    getCmsProductGroupFeatureListRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FEATURE_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FEATURE_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FEATURE_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsProductGroupFeature = (data, id) => {
  return (dispatch) => {
    postCmsProductGroupFeatureRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_PRODUCT_GROUP_FEATURE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_PRODUCT_GROUP_FEATURE_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsProductGroupFeature = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_PRODUCT_GROUP_FEATURE_REQUEST" });
    getCmsProductGroupFeatureListRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FEATURE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FEATURE_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_GROUP_FEATURE_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsFeatureList = (id, data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_FEATURE_LIST_REQUEST" });
    getCmsFeatureListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_FEATURE_LIST_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_FEATURE_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_FEATURE_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsFeature = (data, id) => {
  return (dispatch) => {
    postCmsFeatureRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(
            postClearEntityCache({ entity_id: id, entity_type: "feature" })
          );
          dispatch({
            type: "POST_CMS_FEATURE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_FEATURE_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsFeature = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_FEATURE_REQUEST" });
    getCmsFeatureListRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_FEATURE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_FEATURE_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_FEATURE_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsFeatureSynonym = (id, data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_FEATURE_SYNONYM_REQUEST" });
    getCmsFeatureSynonymRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_FEATURE_SYNONYM_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_FEATURE_SYNONYM_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_FEATURE_SYNONYM_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsFeatureSynonym = (id, data) => {
  return (dispatch) => {
    postCmsFeatureSynonymRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(
            postClearEntityCache({ entity_id: id, entity_type: "feature" })
          );
          dispatch({
            type: "POST_CMS_FEATURE_SYNONYM_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "POST_CMS_FEATURE_SYNONYM_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "POST_CMS_FEATURE_SYNONYM_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const deleteCmsFeatureSynonyms = (data) => {
  return (dispatch) => {
    deleteCmsWebinarkeywordsRepo(data)
      .then((response) => {
        if (response && response.status === 200) {
          dispatch({
            type: "DELETE_CMS_FEATURE_SYNONYMS_SUCCESS",
            payload: response && response.data,
          });
        } else {
          dispatch({
            tyoe: "DELETE_CMS_FEATURE_SYNONYMS_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "DELETE_CMS_FEATURE_SYNONYMS_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsProductList = (id, data) => {
  return (dispatch) => {
    // dispatch({ type: "GET_CMS_PRODUCT_LIST_REQUEST" });
    getCmsProductListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_PRODUCT_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCT_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

// export const getCmsProductListDialer = (id, data) => {
//   return (dispatch) => {
//     // dispatch({ type: "GET_CMS_PRODUCT_LIST_REQUEST" });
//     getCmsProductListDialerRepo(id, data)
//       .then((response) => {
//         if (response && response.status == 200) {
//           dispatch({
//             type: "GET_CMS_PRODUCT_LIST_DIALER_SUCCESS",
//             payload: response && response.data && response.data.data,
//           });
//         } else {
//           dispatch({
//             type: "GET_CMS_PRODUCT_LIST_DIALER_FAILURE",
//             payload: response && response.message,
//           });
//         }
//       })
//       .catch((error) => {
//         if (error && error.response) {
//           dispatch({
//             type: "GET_CMS_PRODUCT_LIST_DIALER_FAILURE",
//             payload: error && error.message,
//           });
//         }
//       });
//   };
// };

export const postCmsProduct = (data, id) => {
  return (dispatch) => {
    postCmsProductRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_PRODUCT_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_PRODUCT_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsProduct = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_PRODUCT_REQUEST" });
    getCmsProductListRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_PRODUCT_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCT_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsProductTypeList = (id, data) => {
  console.log("....res")

  return (dispatch) => {
    // dispatch({ type: "GET_CMS_PRODUCT_TYPE_LIST_REQUEST" });
    getCmsProductTypeListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          console.log(response, "....res")
          dispatch({
            type: "GET_CMS_PRODUCT_TYPE_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCT_TYPE_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_TYPE_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsProductMappedEntity = (data) => {
  return (dispatch) => {
    // dispatch({ type: "GET_CMS_PRODUCT_ENTITY_MAPPED_REQUEST" });
    getCmsProuductMappedEntityRepo(data)
      .then((response) => {
        console.log("...res",response)
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_PRODUCT_ENTITY_MAPPED_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCT_ENTITY_MAPPED_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
         console.log("...error",error)
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_ENTITY_MAPPED_FAILURE",
            payload: error && error.message,
          });
        }
      });
    };
  };

  export const getCmsProductSellebleType = (data) => {
    return (dispatch) => {
      dispatch({ type: "GET_CMS_PRODUCT_SELLEBLE_TYPE_REQUEST" });
      getCmsProuductSellebleTypeRepo(data)
        .then((response) => {
          if (response && response.status == 200) {
            dispatch({
              type: "GET_CMS_PRODUCT_SELLEBLE_TYPE_SUCCESS",
              payload: response && response.data && response.data.data,
            });
          } else {
            dispatch({
              type: "GET_CMS_PRODUCT_SELLEBLE_TYPE_FAILURE",
              payload: response && response.message,
            });
          }
        })
        .catch((error) => {
          if (error && error.response) {
            dispatch({
              type: "GET_CMS_PRODUCT_SELLEBLE_TYPE_FAILURE",
              payload: error && error.message,
            });
          }
        });
      };
    };
  

  export const getCmsProductMappedEntityCheck = (data) => {
    return (dispatch) => {
      dispatch({ type: "GET_CMS_PRODUCT_MAPPED_ENTITY_CHECK_REQUEST" });
      getCmsProuductMappedEntityCheckRepo(data)
        .then((response) => {
          if (response && response.status == 200) {
            dispatch({
              type: "GET_CMS_PRODUCT_MAPPED_ENTITY_CHECK_SUCCESS",
              payload: response && response.data && response.data.data,
            });
          } else {
            dispatch({
              type: "GET_CMS_PRODUCT_MAPPED_ENTITY_CHECK_FAILURE",
              payload: response && response.message,
            });
          }
        })
        .catch((error) => {
           console.log("...error",error)
          if (error && error.response) {
            dispatch({
              type: "GET_CMS_PRODUCT_MAPPED_ENTITY_CHECK_FAILURE",
              payload: error && error.message,
            });
          }
        });
      };
    };

export const postCmsProductType = (data, id) => {
  return (dispatch) => {
    postCmsProductTypeRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_PRODUCT_TYPE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_PRODUCT_TYPE_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsProductType = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_PRODUCT_TYPE_REQUEST" });
    getCmsProductTypeListRepo(id)
      .then((response) => {
        console.log(response, "....response")
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_PRODUCT_TYPE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_PRODUCT_TYPE_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_PRODUCT_TYPE_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};
export const getCmsMapProductFeatureList = (id, data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_MAP_PRODUCT_FEATURE_LIST_REQUEST" });
    getCmsMapProductFeatureListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_MAP_PRODUCT_FEATURE_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_MAP_PRODUCT_FEATURE_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_MAP_PRODUCT_FEATURE_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsMapProductFeature = (data, id) => {
  return (dispatch) => {
    postCmsMapProductFeatureRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_MAP_PRODUCT_FEATURE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_MAP_PRODUCT_FEATURE_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsMapProductFeature = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_MAP_PRODUCT_FEATURE_REQUEST" });
    getCmsMapProductFeatureListRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_MAP_PRODUCT_FEATURE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_MAP_PRODUCT_FEATURE_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_MAP_PRODUCT_FEATURE_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};
export const getCmsFeatureGroup = () => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_FEATURE_GROUP_REQUEST" });
    getCmsFeatureGroupRepo()
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_FEATURE_GROUP_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_FEATURE_GROUP_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_FEATURE_GROUP_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsLandingPageList = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: "GET_CMS_LANDING_PAGE_LIST_REQUEST" });
    await getCmsLandingPageListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsLandingPage = (data, id) => {
  return (dispatch) => {
    postCmsLandingPageRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_LANDING_PAGE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_LANDING_PAGE_FAILURE",
          payload: error.response && error.response?.data?.data,
        });
      });
  };
};

export const getCmsLandingPage = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_LANDING_PAGE_REQUEST" });
    getCmsLandingPageListRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsLandingPageFaqList = (id, data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_LANDING_PAGE_FAQ_LIST_REQUEST" });
    getCmsLandingPageFaqListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_FAQ_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_FAQ_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_FAQ_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsLandingPageFaq = (data, id) => {
  return (dispatch) => {
    postCmsLandingPageFaqRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_LANDING_PAGE_FAQ_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_LANDING_PAGE_FAQ_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsLandingPageFaq = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_LANDING_PAGE_FAQ_REQUEST" });
    getCmsLandingPageFaqListRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_FAQ_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_FAQ_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_FAQ_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsLandingPageSpgList = (id, data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_LANDING_PAGE_SPG_LIST_REQUEST" });
    getCmsLandingPageSpgListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_SPG_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_SPG_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_SPG_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsLandingPageSpg = (data, id) => {
  return (dispatch) => {
    postCmsLandingPageSpgRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_LANDING_PAGE_SPG_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_LANDING_PAGE_SPG_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsLandingPageSpg = (id) => {
  return async (dispatch) => {
    dispatch({ type: "GET_CMS_LANDING_PAGE_SPG_REQUEST" });
    await getCmsLandingPageSpgListRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_SPG_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_SPG_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_SPG_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsLandingPageBannerList = (id, data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_LANDING_PAGE_BANNER_LIST_REQUEST" });
    getCmsLandingPageBannerListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_BANNER_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_BANNER_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_BANNER_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsLandingPageBanner = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_LANDING_PAGE_BANNER_REQUEST" });
    getCmsLandingPageBannerRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_BANNER_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_BANNER_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_LANDING_PAGE_BANNER_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsLandingPageBanner = (data, id) => {
  return (dispatch) => {
    postCmsLandingPageBannerRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_LANDING_PAGE_BANNER_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_LANDING_PAGE_BANNER_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsUserProductList = (id, data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_USER_PRODUCT_LIST_REQUEST" });
    getCmsUserProductListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_USER_PRODUCT_LIST_SUCCESS",
            payload: response && response.data && response.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_USER_PRODUCT_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_USER_PRODUCT_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsUserProduct = (data, id) => {
  return (dispatch) => {
    editCmsUserProductDetailRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_USER_PRODUCT_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_USER_PRODUCT_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getCmsUserProduct = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_USER_PRODUCT_REQUEST" });
    getCmsUserProductDetailRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_USER_PRODUCT_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_USER_PRODUCT_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_USER_PRODUCT_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const putCmsPaymentDetailUpdate = (data) => {
  return (dispatch) => {
    putCmsPaymentDetailUpdateRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "PUT_PAYMENT_DETAIL_UPDATE_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "PUT_PAYMENT_DETAIL_UPDATE_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "PUT_PAYMENT_DETAIL_UPDATE_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsUserProductSpg = (data, id) => {
  return (dispatch) => {
    postCmsUserProductSpgRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_USER_PRODUCT_SPG_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })

      .catch((error) => {
        dispatch({
          type: "POST_CMS_USER_PRODUCT_SPG_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

// export const postCmsUserProductDetail =(data,id)=>{
//     return (dispatch)=>{
//         postCmsUserProductDetailRepo(data,id)
//         .then((response)=>{
//             if(response&&response.status == 200){
//                 dispatch({type:'POST_USER_PRODUCT_DETAIL_SUCCESS',payload:response && response.data &&response.data.data})
//             }
//         })

//         .catch((error)=>{
//             dispatch({type:'POST_USER_PRODUCT_DETAIL_FAILURE',payload:error.response &&error.response.data})
//         })

//     }
// }

// export const getCmsUserProductDetail = (id)=> {
//     return (dispatch) => {
//         dispatch({type:'GET_USER_PRODUCT_DETAIL_REQUEST'})
//         getCmsUserProductDetailListRepo(id)
//             .then((response) => {
//                 if(response && response.status== 200){
//                     dispatch({type:'GET_USER_PRODUCT_DETAIL_SUCCESS',payload:response && response.data && response.data.data})
//                 }else{
//                     dispatch({type:'GET_USER_PRODUCT_DETAIL_FAILURE',payload:response && response.message})
//                 }
//             })
//             .catch(error => {
//                   if(error && error.response){
//                     dispatch({type:'GET_USER_PRODUCT_DETAIL_FAILURE',payload:error && error.message})
//                   }
//             })
//     }
// }

export const getCmsFeatureGroupsList = (id, data) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_FEATURE_GROUPS_LIST_REQUEST" });
    getFeatureGroupsListRepo(id, data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_FEATURE_GROUPS_LIST_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_FEATURE_GROUPS_LIST_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_FEATURE_GROUPS_LIST_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const getCmsFeatureGroups = (id) => {
  return (dispatch) => {
    dispatch({ type: "GET_CMS_FEATURE_GROUPS_REQUEST" });
    getFeatureGroupsListRepo(id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_CMS_FEATURE_GROUPS_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_CMS_FEATURE_GROUPS_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_CMS_FEATURE_GROUPS_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const postCmsFeatureGroups = (data, id) => {
  return (dispatch) => {
    postCmsFeatureGroupsRepo(data, id)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "POST_CMS_FEATURE_GROUPS_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "POST_CMS_FEATURE_GROUPS_FAILURE",
          payload: error.response && error.response.data,
        });
      });
  };
};

export const getProductMappedEntity = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_PRODUCT_MAPPED_ENTITY_REQUEST" });
    getCmsProductMappedEntityRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_PRODUCT_MAPPED_ENTITY_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_PRODUCT_MAPPED_ENTITY_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_PRODUCT_MAPPED_ENTITY_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};


export const getMapProductsData = (data) => {
  return (dispatch) => {
    dispatch({ type: "GET_MAP_PRODUCTS_DATA_REQUEST" });
    getMapProductsDataRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "GET_MAP_PRODUCTS_DATA_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "GET_MAP_PRODUCTS_DATA_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "GET_MAP_PRODUCTS_DATA_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};

export const putProductSpgMapping = (data) => {
  return (dispatch) => {
    putProductSpgMappingRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch({
            type: "PUT_PRODUCT_SPG_MAPPING_SUCCESS",
            payload: response && response.data && response.data.data,
          });
        } else {
          dispatch({
            type: "PUT_PRODUCT_SPG_MAPPING_FAILURE",
            payload: response && response.message,
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: "PUT_PRODUCT_SPG_MAPPING_FAILURE",
            payload: error && error.message,
          });
        }
      });
  };
};